const features = [
  {
    title: '顶流恋情大揭秘',
    desc: '独家整理近期最受关注的明星恋情风波，从蛛丝马迹到正式官宣，全过程还原，满足你的八卦好奇心。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20illustration%20of%20two%20silhouettes%20facing%20each%20other%20with%20soft%20romantic%20atmosphere%2C%20coral%20and%20amber%20gradient%20background%2C%20minimal%20modern%20style%2C%20subtle%20heart%20shapes%20floating%2C%20clean%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '热度 980万',
  },
  {
    title: '综艺决赛独家前瞻',
    desc: '热门综艺总决赛即将到来，我们为你整理了选手实力分析、往期精彩回顾以及最终预测，提前锁定冠军人选。',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20stage%20performance%20illustration%20with%20spotlight%20effects%20and%20silhouettes%2C%20warm%20coral%20amber%20color%20palette%2C%20modern%20flat%20design%2C%20entertainment%20show%20theme%2C%20clean%20minimal%20background&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '热度 860万',
  },
  {
    title: '影视剧首播口碑榜',
    desc: '近期多部热门影视剧陆续开播，我们整理了各家评分与观众真实反馈，帮你快速筛选值得追的好剧。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20film%20reel%20and%20popcorn%20illustration%20in%20warm%20coral%20and%20amber%20tones%2C%20modern%20minimal%20style%2C%20entertainment%20media%20theme%2C%20clean%20composition%20with%20soft%20gradients&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '热度 750万',
  },
  {
    title: '网红圈年度大事件',
    desc: '从头部主播翻车到新晋网红崛起，盘点今年最具话题性的网红圈事件，还原事件全貌与背后的故事。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20influencer%20themed%20illustration%20with%20speech%20bubbles%20and%20trending%20icons%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20flat%20design%2C%20minimal%20background&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '热度 620万',
  },
  {
    title: '跨界合作大盘点',
    desc: '明星跨界品牌代言、艺人创业转型，一文看懂娱乐圈各路明星的商业版图与最新跨界动向。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20business%20handshake%20and%20star%20shapes%20illustration%20in%20warm%20coral%20amber%20gradient%2C%20modern%20minimal%20editorial%20style%2C%20clean%20professional%20composition&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '热度 580万',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">焦点速递</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">本周最受关注的吃瓜焦点，一篇都不容错过</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item) => (
            <a
              key={item.title}
              href="#updates"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#updates');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="group block bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:bg-background-200/40 transition-colors"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 right-2 text-xs px-2 py-0.5 rounded-full bg-background-50/90 text-primary-600 whitespace-nowrap font-medium">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}